var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondTip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EBD5C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.9198L20.2133 20.9998H27.76L24 14.9198Z",
    fill: "#B0654D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35.093L28 21.8797H20L24 35.093Z",
    fill: "#B0654D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 21.8798L22.6667 36.0531C22.8643 36.2752 23.1174 36.4408 23.4 36.5331L19.0133 21.8665L10.6667 21.8798Z",
    fill: "#B0654D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 20.9998C37.3403 20.9877 37.344 20.9739 37.344 20.9598C37.344 20.9458 37.3403 20.932 37.3333 20.9198L33.64 14.8398C33.4977 14.609 33.3008 14.4167 33.0667 14.2798C32.8276 14.1548 32.563 14.0864 32.2933 14.0798H24.5067L28.7867 20.9998H37.3333Z",
    fill: "#B0654D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4667 14.0798H15.7067C15.4318 14.0795 15.1613 14.1483 14.92 14.2798C14.6724 14.408 14.4649 14.6017 14.32 14.8398L10.6667 20.9198C10.6596 20.932 10.6559 20.9458 10.6559 20.9598C10.6559 20.9739 10.6596 20.9877 10.6667 20.9998H19.2133L23.4667 14.0798Z",
    fill: "#B0654D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4533 36.5597C24.7359 36.4674 24.989 36.3018 25.1867 36.0797L37.1867 21.933H28.8667L24.4533 36.5597Z",
    fill: "#B0654D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondTip);
export default __webpack_public_path__ + "static/media/diamond-tip.0f42960f9b05a77034104b07645b9772.svg";
export { ForwardRef as ReactComponent };